import { useUserContext, useDataContext } from "../contexts";
import Form from "./Form";
import { getJobFields } from "../utils";
import { ADMIN } from "../constants";

export default function JobAdd({ callback }) {
  const { user } = useUserContext();
  const { memberUsers } = useDataContext();

  const availableTo = user.profileType === ADMIN ? [] : [user.id];

  const jobFields = getJobFields(memberUsers);

  return (
    <Form
      path="jobs"
      fields={jobFields}
      submitCallback={callback}
      initialValues={{
        rewardAmount: 1,
        family: user.family.id,
        availableTo,
      }}
    />
  );
}
